import { eq } from 'ember-truth-helpers';
import Component from '@glimmer/component';
import styles from './avatar.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class Avatar extends Component {
  initialsFor(user) {
    const splitName = user.name.trim().split(' ');
    return splitName.reduce((acc, value, index) => {
      if (index === 0 || index === splitName.length - 1) {
        const firstChar = Array.from(value)[0];
        if (firstChar) {
          acc = `${acc}${firstChar.toUpperCase()}`;
        }
      }
      return acc;
    }, '');
  }

  get showConversationTypeIcon() {
    return this.args.isGroup || this.args.isCouple;
  }

  get conversationTypeIconName() {
    if (this.args.isGroup) return 'messaging-group-conversation';
    if (this.args.isCouple) return 'messaging-couple-conversation';
    return null;
  }

  get usersCount() {
    return this.args.users?.length ?? 0;
  }

  <template>
    <div class="{{styles.component}} avatar-container">
      {{#if this.showConversationTypeIcon}}
        <span
          class="icon {{if @isGroup 'group'}} {{if @isCouple 'couple'}}"
          data-test-conversation-icon
        >
          {{#if @isGroup}}
            <span class="count-badge" data-test-count-badge>
              {{this.usersCount}}
            </span>
          {{/if}}
          {{svgJar this.conversationTypeIconName}}
        </span>
      {{else}}
        {{#each @users as |user|}}
          {{#let (eq user.externalScope "Client") as |isClient|}}
            <span class="initials {{if isClient 'client'}}" data-test-initials>
              {{this.initialsFor user}}
            </span>
          {{/let}}
        {{/each}}
      {{/if}}
    </div>
  </template>
}
